export const HOURS = Array.from({ length: 24 }, (_, h) => h);
// The aging period of unanswered events (WATCH_AGING in portal/shared/watch-settings.mjs, which pulls node:crypto and so
// is not imported here; a test keeps the two equal). The portal refuses anything outside the range.
export const WATCH_AGING = Object.freeze({ defaultDays: 180, minDays: 30, maxDays: 365 });
export const agingDaysValid = (v) => Number.isInteger(v) && v >= WATCH_AGING.minDays && v <= WATCH_AGING.maxDays;
export const pad = (h) => String(h).padStart(2, '0');
export const GROUP_STATUS_LABEL = Object.freeze({ pending: 'checking', 'not-found': 'not found', ambiguous: 'more than one match' });

const groupKey = (g) => String(g).trim().toLowerCase();

/** Trimmed, non-empty lines, one per group, the first spelling of a group kept (Entra names are case-insensitive). */
export function linesOf(text) {
  const seen = new Set();
  const out = [];
  for (const raw of String(text).split('\n')) {
    const line = raw.trim();
    if (line && !seen.has(groupKey(line))) { seen.add(groupKey(line)); out.push(line); }
  }
  return out;
}

/** The digest hour in the admin's own time zone, for showing next to the UTC hour. */
export function localEquivalent(hourUtc, now = new Date(), timeZone) {
  const at = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), hourUtc));
  return new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hourCycle: 'h23', ...(timeZone ? { timeZone } : {}) }).format(at);
}

/**
 * Only the fields that differ from what the portal returned (PATCH /watch/settings). `enabled` and the
 * per-event toggles are not here: the first is derived from the Notifications switch, the second are
 * the switches of the Rules table.
 */
export function buildSettingsPatch(before, draft) {
  const patch = {};
  for (const k of ['notifyGuestOwners', 'digestHourUtc']) if (draft[k] !== before[k]) patch[k] = draft[k];
  if (draft.agingDays !== undefined && draft.agingDays !== (before.agingDays ?? WATCH_AGING.defaultDays)) patch.agingDays = draft.agingDays;
  const audiences = Object.fromEntries(Object.entries(draft.audiences).filter(([k, v]) => before.audiences[k] !== v));
  if (Object.keys(audiences).length) patch.audiences = audiences;
  const beforeGroups = before.watchedGroups.map((g) => groupKey(g.lookup));
  const draftGroups = draft.watchedGroups.map((g) => String(g).trim()).filter(Boolean);
  if (draftGroups.length !== beforeGroups.length || draftGroups.some((g, i) => groupKey(g) !== beforeGroups[i])) patch.watchedGroups = draftGroups;
  return patch;
}
